import React from 'react';
import { CircularProgress } from '@mui/material';

/**
 * Small, reusable {@link https://mui.com/material-ui/api/circular-progress/ CircularProgress} for buttons, table cells, and inline use.
 * Forwards all other props to MUI `CircularProgress`.
 *
 * @param {Object} props
 * @param {number} [props.size=20]
 * @param {import('@mui/material').CircularProgressProps['color']} [props.color='primary']
 * @param {import('@mui/material').CircularProgressProps} props - Remaining MUI props (e.g. `sx`, `thickness`, `className`)
 */
const InlineSpinner = ({ size = 20, color = 'primary', ...rest }) => {
    return <CircularProgress size={size} color={color} {...rest} />;
};

export default InlineSpinner;
